import { configureStore } from '@reduxjs/toolkit'
import { default as reducers } from './combineReducers'
import { changeLanguage } from './customMiddleware/changeLanguage' // 自定义中间件 - 語言切換
import { logout } from './customMiddleware/logout' // 自定义中间件 - 語言切換
import { persistStore } from 'redux-persist' // redux 数据持久化

export const store = configureStore({
    reducer: reducers,
    middleware: getDefaultMiddleware => [
        ...getDefaultMiddleware({
            serializableCheck: false, // 关闭 persist 插件造成的 redux 不可序列化错误
            immutableCheck: false, // 关闭开发状态检查超时提示， https://github.com/reduxjs/redux-toolkit/issues/415
        }),
        changeLanguage, // 切換語言中間件
        logout,
    ],
    devTools: true,
})

export const persistor = persistStore(store) // 包装 store
